<div #logo class="logo">
  <svg
    class="rtis-logo-svg"
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 250 100"
  >
    <defs>
      <style>
        .cls-1 {
          fill: #ee4524;
        }

        .cls-1,
        .cls-2,
        .cls-3,
        .cls-4,
        .cls-5 {
          stroke-width: 0px;
        }

        .cls-2 {
          fill: currentColor;
        }

        .cls-3 {
          fill: #3ab451;
        }

        .cls-4 {
          fill: #3bbdee;
        }
        .cls-5 {
          fill: #f79821;
        }
      </style>
    </defs>
    <g id="rtis-text">
      <path
        class="cls-2"
        d="m106.54,70.17c-.28,0-.55-.11-.66-.33l-8.47-12.24h-8.75c-.44,0-.83.39-.83.83v10.91c0,.44-.39.83-.83.83h-8.81c-.44,0-.83-.39-.83-.83V25.81c0-.44.39-.83.83-.83h18.72c3.99,0,7.48.66,10.41,1.99,2.94,1.33,5.21,3.21,6.81,5.7,1.61,2.44,2.38,5.37,2.38,8.7s-.83,6.26-2.44,8.7c-1.44,2.16-3.43,3.93-5.98,5.15-.44.22-.61.78-.33,1.22l8.64,12.41c.39.55,0,1.33-.67,1.33h-9.19Zm-3.05-34.62c-1.66-1.33-4.04-2.05-7.15-2.05h-7.7c-.44,0-.83.39-.83.83v14.07c0,.44.39.83.83.83h7.7c3.16,0,5.54-.66,7.15-2.05,1.66-1.38,2.44-3.32,2.44-5.82s-.83-4.49-2.44-5.82"
      />
      <path
        class="cls-2"
        d="m141.05,33.5h-12.79c-.44,0-.83-.39-.83-.83v-6.87c0-.44.39-.83.83-.83h37.72c.44,0,.83.39.83.83v6.87c0,.44-.39.83-.83.83h-12.79c-.44,0-.83.39-.83.83v35c0,.44-.39.83-.83.83h-8.81c-.44,0-.83-.39-.83-.83v-35c0-.44-.39-.83-.83-.83"
      />
      <path
        class="cls-2"
        d="m181.59,24.97h8.81c.44,0,.83.39.83.83v43.48c0,.44-.39.83-.83.83h-8.81c-.44,0-.83-.39-.83-.83V25.8c0-.44.39-.83.83-.83"
      />
      <path
        class="cls-2"
        d="m214.77,69.45c-3.05-.89-5.54-1.99-7.48-3.38-.33-.22-.44-.66-.28-1l2.88-6.37c.22-.44.78-.66,1.22-.33,1.77,1.16,3.82,2.1,6.09,2.88,2.66.89,5.32,1.27,7.98,1.27,2.99,0,5.15-.44,6.59-1.33,1.44-.89,2.1-2.05,2.1-3.49,0-1.05-.44-1.99-1.27-2.66-.83-.66-1.94-1.27-3.21-1.72-1.33-.44-3.1-.89-5.32-1.44-3.43-.83-6.26-1.61-8.47-2.44-2.21-.83-4.1-2.11-5.65-3.93-1.55-1.83-2.38-4.21-2.38-7.2,0-2.6.72-4.99,2.11-7.15,1.38-2.16,3.54-3.82,6.42-5.04,2.88-1.27,6.37-1.88,10.47-1.88,2.88,0,5.7.33,8.47,1.05,2.49.61,4.71,1.49,6.59,2.6.33.22.5.67.33,1.05l-2.6,6.42c-.17.44-.72.67-1.16.39-3.88-2.05-7.81-3.1-11.69-3.1-2.94,0-5.1.5-6.48,1.44-1.38.94-2.11,2.22-2.11,3.77s.83,2.71,2.44,3.43c1.61.77,4.1,1.49,7.37,2.22,3.43.83,6.26,1.66,8.47,2.44,2.22.83,4.1,2.11,5.65,3.88,1.55,1.77,2.38,4.15,2.38,7.14,0,2.6-.72,4.93-2.16,7.09-1.44,2.1-3.6,3.82-6.48,5.04-2.88,1.27-6.37,1.88-10.52,1.88-3.49-.06-6.92-.55-10.3-1.55"
      />
    </g>
    <g id="iri-text">
      <rect
        class="cls-2"
        x="32.51"
        y="39.29"
        width="2.1"
        height="7.57"
        transform="translate(-20.63 36.35) rotate(-45)"
      />
      <path
        class="cls-2"
        d="m43.58,38.41l-3.03-.91-.16.16,1.97,1.97-1.49,1.49-5.35-5.35,2.34-2.34c.43-.43.87-.72,1.32-.87.45-.15.88-.17,1.29-.06.41.11.78.33,1.1.65.36.36.58.78.66,1.26.08.48-.02.96-.29,1.46l3.29.88-1.66,1.66Zm-4.21-1.77l.74-.74c.2-.2.31-.4.31-.6,0-.2-.08-.39-.27-.57-.17-.17-.36-.26-.56-.25-.2,0-.4.11-.6.3l-.74.74,1.12,1.12Z"
      />
      <rect
        class="cls-2"
        x="45.94"
        y="25.87"
        width="2.1"
        height="7.57"
        transform="translate(-7.2 41.91) rotate(-45)"
      />
    </g>
    <path
      class="cls-2"
      id="growth-arrow"
      d="m56.41,25.21c-4.27.21-4.67.28-5.09.8-.12.15-.26.46-.33.69-.19.72,0,1.05,1.57,2.64.77.78,1.41,1.49,1.41,1.54s-4.29,4.38-9.52,9.61l-9.53,9.53-4.46-4.46c-4.9-4.89-4.93-4.91-6.15-4.92-.46,0-.77.07-1.13.24-.35.18-2.17,1.93-6.59,6.36-5.52,5.53-6.12,6.17-6.27,6.63-.37,1.13-.1,2.11.86,3.05.84.82,1.36,1.07,2.2,1.07q1.24,0,6.34-5.1l4.65-4.63,4.49,4.46c2.77,2.76,4.63,4.53,4.87,4.64.62.29,1.25.33,1.95.13l.62-.17,11.05-11.05,11.05-11.04,1.53,1.5c1.25,1.23,1.6,1.52,1.93,1.58.97.18,1.93-.57,2.11-1.66.03-.2.16-2.6.29-5.33l.23-4.94-.23-.47c-.38-.79-.76-.93-2.46-.92-.79,0-3.22.1-5.41.21"
    />
    <polygon
      class="cls-3 logo-bar"
      points="54.42 43.9 50.37 47.96 50.37 59.21 50.37 70.47 50.64 70.76 50.93 71.03 54.71 71.03 58.5 71.03 58.79 70.76 59.06 70.47 59.06 55.44 59.06 40.41 58.76 40.12 58.47 39.84 54.42 43.9"
    />
    <path
      class="cls-4 logo-bar"
      d="m43.05,55.27c-2.13,2.13-4.1,4.05-4.37,4.28l-.51.38v10.44l.28.33.27.33h7.62l.25-.25c.14-.14.27-.41.32-.6.03-.2.04-4.5.03-9.57l-.03-9.2-3.87,3.87Z"
    />
    <path
      class="cls-5 logo-bar"
      d="m25.96,62.33c0,8.28,0,8.31.51,8.58.15.07,1.49.12,3.98.12h3.76l.28-.33.27-.33-.02-4.73-.03-4.74-.58-.06c-.72-.07-1.24-.24-2.07-.66-.51-.25-1.14-.82-3.29-2.95-1.47-1.46-2.69-2.64-2.74-2.64-.04,0-.07,3.49-.07,7.75"
    />
    <path
      class="cls-1 logo-bar"
      d="m19.76,57.43c-1.92,1.9-2.94,2.84-3.34,3.07-.65.35-1.41.61-2.09.72l-.46.07v9.18l.28.29.29.27h7.61l.25-.27.26-.29v-7.88c0-4.34-.01-7.89-.02-7.89-.02,0-1.27,1.23-2.79,2.74"
    />
  </svg>
</div>
